@use "foundation/_colors.scss";

.progress-item {
  box-sizing: border-box;
  border-radius: .5em;
  margin-top: 1em;
  padding: .5em 1em;

  font-weight: 700;
  line-height: 2em;

  display: flex;
  justify-content: space-between;
  align-items: center;

  &.passing {
    background-color: colors.$secondary-clover-light;
    color: colors.$secondary-clover;

    svg {
      width: 1em;
      path {
        fill: colors.$secondary-clover !important;
      }
    }
  }

  &.failing {
    box-sizing: border-box;
    border-radius: .5em;
    margin-top: 1em;
    padding: .5em 1em;

    font-weight: 700;
    line-height: 2em;

    background-color: colors.$error-color;

    &:hover {
      opacity: .85;
    }

    div {
      color: colors.$primary-white;
    }
  }

  &.skippable {
    background-color: colors.$primary-white;
    border: 3px solid colors.$neutrals-light-grey;
    color: colors.$neutrals-grey;

    div {
      color: colors.$neutrals-grey;
    }

    button {
      color: colors.$secondary-blue;
      font-size: 1em;
      font-weight: bold;
      cursor: pointer;

      &:disabled {
        color: colors.$neutrals-grey;
      }
    }

    &:hover {
      opacity: .85;
    }
  }
}
